function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../css/style.css';
import '../css/libstyle.css';
import { libstyle } from './styleParser';

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon(props) {
    _classCallCheck(this, Icon);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleIconClick = _this.handleIconClick.bind(_this);
    _this.handleOnMouseDown = _this.handleOnMouseDown.bind(_this);
    _this.handleIconMouseOut = _this.handleIconMouseOut.bind(_this);
    _this.handleIconMouseOver = _this.handleIconMouseOver.bind(_this);
    return _this;
  }

  Icon.prototype.handleIconClick = function handleIconClick(evt) {
    if (this.props.onIconClick) {
      this.props.onIconClick(evt, this.props.name);
    }
  };

  Icon.prototype.handleOnMouseDown = function handleOnMouseDown(evt) {
    if (this.props.onIconMouseDown) {
      this.props.onIconMouseDown(evt, this.props.name);
    }
  };

  Icon.prototype.handleIconMouseOut = function handleIconMouseOut() {
    if (this.props.onIconMouseOut) {
      this.props.onIconMouseOut();
    }
  };

  Icon.prototype.handleIconMouseOver = function handleIconMouseOver() {
    if (this.props.onIconMouseOver) {
      this.props.onIconMouseOver();
    }
  };

  Icon.prototype.render = function render() {
    var firstColor = '#000';
    var secondColor = '#c6c6c6';
    var primaryColor = firstColor;

    if (this.props.primaryColor) {
      primaryColor = this.props.primaryColor;
    }

    if (this.props.inverted) {
      if (!this.props.secondaryColor) {
        primaryColor = secondColor;
      } else {
        primaryColor = this.props.secondaryColor;
      }
    }

    var secondaryColor = secondColor;

    if (this.props.secondaryColor) {
      secondaryColor = this.props.secondaryColor;
    }

    if (this.props.inverted) {
      if (!this.props.primaryColor) {
        secondaryColor = firstColor;
      } else {
        secondaryColor = this.props.primaryColor;
      }
    }

    var classes = [];
    classes.push('pdc-ic-icon-' + this.props.name);
    classes.push('pdc-ic-icon');
    var style = {
      verticalAlign: 'middle',
      color: primaryColor
    };

    if (this.props.size) {
      style.fontSize = this.props.size;
    }

    var wrapperStyle = {};

    if (this.props.onIconClick || this.props.onIconMouseDown) {
      wrapperStyle.cursor = 'pointer';
    }

    if (this.props.padding) {
      wrapperStyle.padding = this.props.padding;
    }

    if (this.props.shape != undefined) {
      if (this.props.shape === SHAPES.CIRCLE) {
        wrapperStyle.borderRadius = '50%';
      } else if (this.props.shape === SHAPES.ROUNDEDSQUARE) {
        wrapperStyle.borderRadius = '20%';
      } else if (this.props.shape === SHAPES.SQUARE) {
        wrapperStyle.borderRadius = '0%';
        ;
      }
    } else {
      secondaryColor = undefined;
    }

    if (!this.props.border) {
      wrapperStyle.backgroundColor = secondaryColor;
      wrapperStyle.borderStyle = 'none';
      wrapperStyle.borderWidth = 0;
    } else {
      wrapperStyle.borderColor = secondaryColor;
      wrapperStyle.borderStyle = 'solid';
      wrapperStyle.borderWidth = this.props.border;
    }

    return React.createElement('div', {
      className: ['pdc-ic-icon', libstyle.icon].join(' '),
      'data-id': this.props['data-id'],
      'data-type': this.props['data-type'],
      style: wrapperStyle,
      onClick: this.handleIconClick,
      onMouseDown: this.handleOnMouseDown,
      onMouseOut: this.handleIconMouseOut,
      onMouseOver: this.handleIconMouseOver
    }, React.createElement('span', {
      className: classes.join(' '),
      style: style
    }));
  };

  return Icon;
}(Component);

Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  size: PropTypes.string,
  shape: PropTypes.string,
  border: PropTypes.number,
  inverted: PropTypes.bool,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onIconClick: PropTypes.func,
  onIconMouseDown: PropTypes.func,
  onIconMouseOut: PropTypes.func,
  onIconMouseOver: PropTypes.func,
  'data-id': PropTypes.string,
  'data-type': PropTypes.string
} : {};
var SHAPES = {
  CIRCLE: 'shapeCircle',
  SQUARE: '',
  ROUNDEDSQUARE: 'shapeRoundedSquare'
};
export { SHAPES };
export default Icon;